import React from "react";
import "./MyBookingsListMobileWrapper.scss";
import ListOfBookingCards  from "../../MyBookings/UI/ListOfBookingCards";
import { RefreshTimer } from "../../MyBookings/RefreshTimer";
import TrackVisibility from 'react-on-screen';
import { TrackVisibilityBlock } from "./TrackVisibilityBlock";
import { GoogleMapScriptLoader } from "../../../widgets/google-maps/GoogleMapScriptLoader";

/**
 * Wrapper component of my bookings for mobile device.
 * Also, it is embeded with components, such as RefreshTimer, to refresh bookings.
 */
export const MyBookingsListMobileWrapper: React.FC = () => {
    return (
        <>
            {/* Adds a google maps API script <GoogleMapScriptLoader>, as required for ETA loading */}
            <GoogleMapScriptLoader>
                <RefreshTimer />
            </GoogleMapScriptLoader>
            <div className="mobile-active-booking-panel">
                <TrackVisibility partialVisibility>
                    <TrackVisibilityBlock/>
                </TrackVisibility>

                <ListOfBookingCards />
            </div>
        </>
    );
}
